export const getRowCollectionId = (rowEl: HTMLDivElement | undefined) => {
  return rowEl && rowEl.dataset.collectionId;
};
